module.exports = __webpack_public_path__ + "static/media/downloadNew.57ad54bf.svg";